import { Link } from 'react-router-dom';
import { sportEvents } from '@/mocks/sports';

const statusConfig: Record<string, { label: string; className: string }> = {
  live: { label: '直播中', className: 'bg-accent-500 text-foreground-950' },
  upcoming: { label: '即将开始', className: 'bg-primary-500 text-white' },
  finished: { label: '已结束', className: 'bg-secondary-500 text-white' },
};

export default function EventsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-4">
            热门赛事
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精彩赛事推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            实时追踪全球顶级体育赛事，足球、篮球、网球、电竞等精彩对决一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {sportEvents.map(event => (
            <Link
              key={event.id}
              to={`/category/${event.categorySlug}`}
              className="group bg-background-100 rounded-2xl p-5 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="text-xs text-foreground-500 font-medium">{event.league}</span>
                <span className={`px-2.5 py-0.5 text-xs font-semibold rounded-full whitespace-nowrap ${statusConfig[event.status].className}`}>
                  {statusConfig[event.status].label}
                </span>
              </div>

              <div className="flex items-center justify-between gap-3">
                <div className="flex flex-col items-center gap-2 flex-1">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-200 overflow-hidden">
                    <img src={event.team1Logo} alt={event.team1} title={event.team1} className="w-full h-full object-cover" />
                  </div>
                  <span className="text-sm font-semibold text-foreground-800">{event.team1}</span>
                </div>

                <div className="flex flex-col items-center gap-1 min-w-[60px]">
                  {event.status === 'upcoming' ? (
                    <>
                      <span className="text-xs text-foreground-400">{event.date}</span>
                      <span className="text-lg font-bold text-foreground-950">VS</span>
                      <span className="text-xs text-foreground-400">{event.time}</span>
                    </>
                  ) : (
                    <>
                      <span className="text-xs text-foreground-400">{event.date}</span>
                      <span className="text-xl md:text-2xl font-black text-foreground-950 tracking-tight">{event.score}</span>
                      <span className="text-xs text-foreground-400">{event.time}</span>
                    </>
                  )}
                </div>

                <div className="flex flex-col items-center gap-2 flex-1">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-200 overflow-hidden">
                    <img src={event.team2Logo} alt={event.team2} title={event.team2} className="w-full h-full object-cover" />
                  </div>
                  <span className="text-sm font-semibold text-foreground-800">{event.team2}</span>
                </div>
              </div>

              <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between">
                <span className="text-xs text-foreground-500">
                  <i className="ri-calendar-line mr-1"></i>{event.date} {event.time}
                </span>
                <span className="text-xs text-primary-600 group-hover:text-primary-500 font-medium transition-colors whitespace-nowrap">
                  查看详情 <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/football"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-foreground-600 bg-background-100 rounded-full border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-all cursor-pointer"
          >
            查看全部赛事 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}